import React from "react";
import { connect, DispatchProp } from "react-redux";
import { Page } from "../../components/page/Page";
import { PageModel } from "../../models/PageModel";
import { QuestionModel } from "../../models/QuestionModel";
import { StoreState } from "../../models/states/StoreState";
import { Voxco } from "../../public";
import { ThemeModel } from "../../models/ThemeModel";
import { QuestionnaireModel } from "../../models/QuestionnaireModel";
import { translate } from "../../models/utilities/translationUtilities";
import { ValidationResultModel } from "../../models/ValidationResultModel";
import { getContainerDiv } from "../../utils";
import {
    selectNavigationDisabled,
    selectNavigationMessage,
} from "../../redux/selectors/interview/navigation";

interface OwnProps {
    isDesktopPreviewView?: boolean;
}

interface StateProps {
    isValid: boolean;
    message: string | Error;
    validation: ValidationResultModel;
    questionnaire: QuestionnaireModel;
    isNavigationDisabled: boolean;
    page?: PageModel;
    questions: QuestionModel[];
    language: string;
    title: string;
    theme: ThemeModel;
    useClientValidation: boolean;
    parent?: string;
}

type Props = OwnProps & StateProps;

class PageContainerImpl extends React.PureComponent<Props & DispatchProp> {
    componentDidMount() {
        const { page } = this.props;
        if (page !== undefined && page.isReady) {
            this.onPageReady(page);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: StateProps) {
        const { page } = this.props;
        if (page !== nextProps.page) {
            const surveyEngine = getContainerDiv();
            if (surveyEngine !== undefined) surveyEngine.scrollTop = 0;
        }
    }

    componentDidUpdate(prevProps: Props) {
        const { page: prevPage } = prevProps;
        const { page } = this.props;
        if (page !== prevPage && page !== undefined && page.isReady) {
            this.onPageReady(page);
        }
    }

    onPageReady(page: PageModel) {
        Voxco.trigger("pageReady", page);
    }

    render() {
        const { message, page } = this.props;
        return (
            <div role="region" aria-live="polite" className="pageContainer">
                {(message || page?.isReady) && (
                    <Page
                        {...this.props}
                        matrixIndex={page?.loopIndex ?? 1}
                        progress={page?.progress ?? 0}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: StoreState, ownProps: OwnProps): Props => {
    const { navigation, questionnaire, validation, language, theme } = state.interview;
    const { currentPage } = navigation ?? {};
    return {
        message: selectNavigationMessage(state),
        questionnaire,
        validation,
        isNavigationDisabled: selectNavigationDisabled(state),
        isValid: validation.isValid,
        page: currentPage,
        questions: currentPage?.questions ?? [],
        language,
        theme,
        title: translate(theme, "SurveyTitle", language),
        useClientValidation: state.interview.useClientValidation,
        isDesktopPreviewView: ownProps.isDesktopPreviewView,
        parent: state.application.parent,
    };
};

export const PageContainer = connect(mapStateToProps)(PageContainerImpl);
